import { render, staticRenderFns } from "./CardPublisherSummary.vue?vue&type=template&id=3cf739c6&"
import script from "./CardPublisherSummary.vue?vue&type=script&lang=js&"
export * from "./CardPublisherSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports